<!--
  ChangelogLoadingState.vue
  
  Loading spinner displayed while changelog is being fetched.
  
  @component
-->
<template>
  <div class="flex items-center justify-center py-12">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500" />
  </div>
</template>

<script setup lang="ts">
// No props or logic needed - simple loading indicator
</script>
